<template>
    <div>

        <div class="vueWiVContainer">
            <div class="vueWivSearchBar_container">
                <input class="vueWivSearchBar_input" v-model="searchTerm" placeholder="Search..."
                    @keyup.enter="performUnifiedSearch" />
                <button class="vueWivSearchBar_button" @click="performUnifiedSearch">Search</button>
            </div>
            <div class="dropdownContainer">
                <DropdownFilter title="Job Title" placeholder="Select filters..." :items="practiceTypeNames"
                    @item-toggled="handleItemsToggle" />
                <DropdownFilter title="Job Details" placeholder="Select filters..." :items="jobTypeNames"
                    @item-toggled="handleItemsToggle" />
                <DropdownFilter title="Full-time / Part-time" placeholder="Select filters..." :items="fullPartTimeNames"
                    @item-toggled="handleItemsToggle" />
                <DropdownFilter title="Practice Setting" placeholder="Select filters..." :items="clinicTypeNames"
                    @item-toggled="handleItemsToggle" />
                <DropdownFilter title="Communities" placeholder="Select filters..." :items="communityNames"
                    @item-toggled="handleItemsToggle" />
            </div>
        </div>

        <div class='resultCounter' v-if="!isSmallScreen">{{ jobs.length }} Results </div>

        <!-- Content desktop -->
        <div class="contentContainer" v-if="!isSmallScreen">
            <!-- Large section on the left -->
            <div class="leftSection">
                <Gmaps :markers="mapMarkers"></Gmaps>
            </div>

            <!-- List section on the right -->
            <div class="rightSection">
                <div class="jobListing" v-for="job in jobs" :key="job.id">
                    <div v-html="job.title.rendered"></div>
                    <button class="seeMore"><a :href=job.link>See More</a></button>
                </div>
                <div v-if="jobs.length == 0" class='noResultsAvailable'>
                    No available positions based on your filter selection
                </div>
            </div>
        </div>
        <!-- /////////////////////////////////////////////////// -->

        <!-- Content mobile -->
        <div class="contentContainer" v-if="isSmallScreen">
            <!-- Toggle Buttons -->
            <div class="toggleButtons">
                <div :class="{ active: currentView === 'list' }" class="buttonToggleMapMobile"
                    @click="currentView = 'list'">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M7 5H21V7H7V5ZM7 13V11H21V13H7ZM4 4.5C4.39782 4.5 4.77936 4.65804 5.06066 4.93934C5.34196 5.22064 5.5 5.60218 5.5 6C5.5 6.39782 5.34196 6.77936 5.06066 7.06066C4.77936 7.34196 4.39782 7.5 4 7.5C3.60218 7.5 3.22064 7.34196 2.93934 7.06066C2.65804 6.77936 2.5 6.39782 2.5 6C2.5 5.60218 2.65804 5.22064 2.93934 4.93934C3.22064 4.65804 3.60218 4.5 4 4.5ZM4 10.5C4.39782 10.5 4.77936 10.658 5.06066 10.9393C5.34196 11.2206 5.5 11.6022 5.5 12C5.5 12.3978 5.34196 12.7794 5.06066 13.0607C4.77936 13.342 4.39782 13.5 4 13.5C3.60218 13.5 3.22064 13.342 2.93934 13.0607C2.65804 12.7794 2.5 12.3978 2.5 12C2.5 11.6022 2.65804 11.2206 2.93934 10.9393C3.22064 10.658 3.60218 10.5 4 10.5ZM7 19V17H21V19H7ZM4 16.5C4.39782 16.5 4.77936 16.658 5.06066 16.9393C5.34196 17.2206 5.5 17.6022 5.5 18C5.5 18.3978 5.34196 18.7794 5.06066 19.0607C4.77936 19.342 4.39782 19.5 4 19.5C3.60218 19.5 3.22064 19.342 2.93934 19.0607C2.65804 18.7794 2.5 18.3978 2.5 18C2.5 17.6022 2.65804 17.2206 2.93934 16.9393C3.22064 16.658 3.60218 16.5 4 16.5Z"
                            fill="#006D8A" />
                    </svg>
                    List view
                </div>
                <div :class="{ active: currentView === 'map' }" class="buttonToggleMapMobile" @click="currentView = 'map'">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path
                            d="M17.5 0L17.34 0.03L12 2.1L6 0L0.36 1.9C0.15 1.97 0 2.15 0 2.38V17.5C0 17.78 0.22 18 0.5 18L0.66 17.97L6 15.9L12 18L17.64 16.1C17.85 16.03 18 15.85 18 15.62V0.5C18 0.22 17.78 0 17.5 0ZM12 16L6 13.89V2L12 4.11V16Z"
                            fill="#006D8A" />
                    </svg>
                    On the map
                </div>
            </div>
            <div class='resultCounterMobile'>{{ jobs.length }} Results </div>

            <!-- Section for List View -->
            <div class="listSection" v-if="currentView === 'list'">
                <div class="jobListing" v-for="job in jobs" :key="job.id">
                    <div v-html="job.title.rendered"></div>
                    <button class="seeMore"><a :href="job.link">See More</a></button>
                </div>
                <div v-if="jobs.length == 0" class="noResultsAvailable">
                    No available positions based on your filter selection
                </div>
            </div>

            <!-- Section for Map View -->
            <div class="mapSection" v-if="currentView === 'map'">
                <Gmaps :markers="mapMarkers"></Gmaps>
            </div>
        </div>

        <!-- /////////////////////////////////////////////////// -->




    </div>
</template>

<script>
import DropdownFilter from './components/DropdownFilter.vue';
import Gmaps from './components/Gmaps.vue'

import database from './database'
import { jobType, community, practiceType, fullPartTime, clinicType } from './databaseTaxonomy';

export default {
    name: 'WiV',
    components: { DropdownFilter, Gmaps },
    props: [],
    data() {
        return {
            wpData: wpData || {},

            selectedItems: [],

            searchTerm: '',

            taxonomy1: jobType,
            taxonomy2: community,
            taxonomy3: practiceType,
            taxonomy4: fullPartTime,
            taxonomy5: clinicType,

            databaseJobs: database,
            jobs: [],

            mapMarkers: [
                { lat: 49.27975, lng: -123.118506 },
                { lat: 49.28000, lng: -123.119000 },
            ],

            isSmallScreen: false,

            currentView: 'list',
            showLeftSection: true,
        }
    },
    methods: {

        handleResize() {
            this.isSmallScreen = window.innerWidth < 768;
        },


        handleItemsToggle(selected) {

            if (this.selectedItems.includes(selected.id)) {
                this.selectedItems = this.selectedItems.filter(id => id !== selected.id);
            } else {
                this.selectedItems.push(selected.id);
            }

            if (this.selectedItems.length < 1) {
                this.performUnifiedSearch();
                return;
            }

            this.performUnifiedSearch();
        },

        handleOutsideClick(event) {
            if (!event.target.closest('.dropdown-filter')) {
                this.closeAllDropdowns();
            }
        },

        closeAllDropdowns() {
            this.$children.forEach(child => {
                if (child.$options.name === 'DropdownFilter') {
                    child.closeDropdown();
                }
            });
        },

        populateGoogleMaps(jobs) {
            this.mapMarkers = [];
            jobs.forEach(item => {
                if (item.acf) {
                    let lat = parseFloat(item.acf["job_listing-clinic_lattitude"]);
                    let lng = parseFloat(item.acf["job_listing-clinic_longitude"]);
                    let info = item.title.rendered.replace(/&#8211;/g, '-');
                    let link = item.link;

                    if (!isNaN(lat) && !isNaN(lng)) {
                        this.mapMarkers.push({ lat, lng, info, link });
                    }
                }
            });
        },

        performUnifiedSearch() {
            let results = this.databaseJobs;

            if (this.searchTerm) {
                results = this.handleSearchBar(results);
            }

            if (this.selectedItems.length > 0) {
                results = this.filterPostsBySelectedOptions(results);
            }

            this.jobs = results;
            this.populateGoogleMaps(this.jobs);
        },

        handleSearchBar(posts) {
            const term = this.searchTerm.toLowerCase();
            return posts.filter(job => {
                const title = job.title.rendered.toLowerCase();
                if (title.includes(term)) return true;

                for (let key in job.acf) {
                    let value = job.acf[key];
                    if (Array.isArray(value)) {
                        value = value.join(' ');
                    }

                    if (typeof value !== 'string') continue;
                    if (value.toLowerCase().includes(term)) return true;
                }
                return false;
            });
        },


        filterPostsBySelectedOptions(posts) {
            let filteredItems = [];

            let joblisting_job_typeIds = [13, 15, 323, 17, 324]; //position types
            let joblisting_practice_typeIds = [100, 98, 99];
            let joblisting_clinic_typeIds = [19, 20, 21, 22, 322, 342, 23, 24]; //practice settings
            let joblisting_communityIds = [315,319,321,92,85,87,90,81,88,317,89,86,83,316,91,318,84,82,93,320];
            let joblisting_ft_ptIds = [32, 31];

            let categoryIds = {
                joblisting_practice_type: joblisting_practice_typeIds,
                joblisting_job_type: joblisting_job_typeIds,
                joblisting_clinic_type: joblisting_clinic_typeIds,
                joblisting_community: joblisting_communityIds,
                joblisting_ft_pt: joblisting_ft_ptIds
            };

            function hasIntersection(arr1, arr2) {
                return arr1.some(item => arr2.includes(item));
            }

            function isSelectedInCategory(category, selectedItems) {
                return category.some(id => selectedItems.includes(id));
            }

            // Determine the categories of the selected items
            let selectedCategories = {};
            for (let category in categoryIds) {
                if (isSelectedInCategory(categoryIds[category], this.selectedItems)) {
                    selectedCategories[category] = this.selectedItems.filter(id => categoryIds[category].includes(id));
                }
            }

            // Filter posts
            posts.forEach(post => {
                let matchesAllSelectedCategories = true;

                for (let category in selectedCategories) {
                    if (!hasIntersection(post[category], selectedCategories[category])) {
                        matchesAllSelectedCategories = false;
                        break;
                    }
                }

                if (matchesAllSelectedCategories) {
                    filteredItems.push(post);
                    // console.log(`Post ID ${post.id} matched in all selected categories.`);
                }
            });

            return filteredItems;
        }

        ,




        fetchJobsFromWP(page = 1, allJobs = []) {
            fetch(`${this.wpData.rest_url}wp/v2/job_listing?per_page=100&page=${page}`)
                .then((response) => {
                    const totalPages = parseInt(response.headers.get('X-WP-TotalPages'), 10);

                    return response.json().then((data) => {
                        const combinedData = [...allJobs, ...data]; //database

                        if (page < totalPages) {
                            this.fetchJobsFromWP(page + 1, combinedData);
                        } else {
                            let lessMarkersOnLoad = combinedData.slice(0, 100);
                            // console.log(lessMarkersOnLoad)
                            this.populateGoogleMaps(lessMarkersOnLoad);
                            this.jobs = lessMarkersOnLoad;
                            this.databaseJobs = combinedData;
                        }
                    });
                })
                .catch((error) => {
                    console.error(error);
                });
        },
    },


    mounted() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);

        this.fetchJobsFromWP();
        document.addEventListener('click', this.handleOutsideClick);
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
        document.removeEventListener('click', this.handleOutsideClick);
    },

    computed: {
        jobTypeNames() {
            return this.taxonomy1.map(item => ({ name: item.name, id: item.id }));
        },
        communityNames() {
            return this.taxonomy2.map(item => ({ name: item.name, id: item.id }));
        },
        practiceTypeNames() {
            return this.taxonomy3.map(item => ({ name: item.name, id: item.id }));
        },
        fullPartTimeNames() {
            return this.taxonomy4.map(item => ({ name: item.name, id: item.id }));
        },
        clinicTypeNames() {
            return this.taxonomy5.map(item => ({ name: item.name, id: item.id }));
        }
    }
}
</script>

<style scoped>
.vueWivSearchBar_container {
    display: flex;
    align-items: center;
    margin-bottom: 25px;
}

.vueWivSearchBar_input {
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    flex-grow: 1;

}

.vueWivSearchBar_button {
    margin-left: 5px;
    background-color: #428DA1;
    font-size: 15px;
    padding: 9.5px 24px;
    border-radius: 4px;
    color: white !important;
    border: none;
    cursor: pointer;
}



.contentContainer {
    display: flex;
    gap: 20px;
}

.dropdownContainer {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    margin-bottom: 70px;
    justify-content: space-between;
}

.leftSection {
    flex: 2;
    background-color: #016d89;
    height: 500px;
}

.rightSection {
    flex: 2;
    overflow-y: auto;
    height: 500px;
}

.jobListing {
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    background-color: #d9e8ec;
    margin-bottom: 5px;
}

.jobListing>div {
    padding: 25px;
    color: #646154;

    font-family: Arial, Helvetica, sans-serif;
    font-size: 16px;
}

.jobListing>button {
    border-radius: 0px !important;
    background-color: #428DA1;
}

.seeMore {
    background-color: #428DA1;
    font-size: 15px;
    padding: 5px 25px;
    font-weight: 300;
    color: white !important;
    border: none;
    cursor: pointer;
}

.seeMore a {
    text-decoration: none;
    color: white !important;

}

.resultCounter {
    font-size: 13px;
    margin-bottom: 10px;
    margin-top: -20px;
}


.resultCounterMobile {
    font-size: 13px;
    margin-bottom: 0px;
    margin-top: 0px;
    font-weight: bold;
}

.noResultsAvailable {
    padding: 30px;
    text-align: center;
    font-size: 25px;
    font-weight: 500;
    color: #016d89;
}

@media (max-width: 768px) {
    .contentContainer {
        display: flex;
        flex-direction: column;
    }

    .toggleButtons {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .buttonToggleMapMobile {
        background-color: white;
        color: #016d89;
        border-radius: 4px;
        border-color: #016d89;
        text-align: center;
        padding: 15px;
        cursor: pointer;

        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
    }

    .dropdown-filter {
        width: 90vw !important;
        position: relative;
    }

    .dropdownContainer {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
        margin-bottom: 70px;
        justify-content: flex-start;
        flex-direction: column;
        align-content: center;
        align-items: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/WiV.vue